export default "__VITE_ASSET__HMwHPbbm__"